import React from 'react'
import { FaApple, FaGooglePlay } from 'react-icons/fa'

const Hero = () => {
  return (
    <section className="pt-24 pb-12 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-primary-50 to-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="text-center lg:text-left">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
              Measure Fish with
              <span className="gradient-text"> One Click</span>
            </h1>
            <p className="mt-6 text-xl text-gray-600 leading-relaxed">
              The ultimate fishing companion app that uses AR technology for instant one-click measurements and AI to identify species automatically.
            </p>
            
            <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <a
                href="https://apps.apple.com/us/app/fish-measure-pro/id6747051635"
                className="inline-flex items-center justify-center px-8 py-4 bg-black text-white rounded-xl hover:bg-gray-800 transition-colors"
              >
                <FaApple className="mr-2 h-6 w-6" />
                <div className="text-left">
                  <div className="text-xs">Download on the</div>
                  <div className="text-lg font-semibold">App Store</div>
                </div>
              </a>
              <div className="text-center">
                <p className="text-sm text-gray-600 mt-4">
                  Available exclusively on iOS 18.2+
                </p>
              </div>
            </div>
            
            <div className="mt-8 flex items-center gap-8 justify-center lg:justify-start">
              <div>
                <div className="text-3xl font-bold text-primary-600">1-Click</div>
                <div className="text-sm text-gray-600">Measurement</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-primary-600">AR</div>
                <div className="text-sm text-gray-600">Technology</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-primary-600">AI</div>
                <div className="text-sm text-gray-600">Fish ID</div>
              </div>
            </div>
          </div>
          
          <div className="relative">
            <div className="relative z-10">
              <img
                src="https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=600&h=800&fit=crop"
                alt="AnglersAI App Screenshot"
                className="rounded-3xl shadow-2xl w-full max-w-md mx-auto"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-600/20 to-transparent rounded-3xl"></div>
            </div>
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-primary-200 rounded-full filter blur-3xl opacity-30 -z-10"></div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero